import qs from "qs";
import React from "react";
import BreedCardCarousel from "../../../components/BreedCardCarousel/BreedCardCarousel";
import { Button } from "../../../components/common";
import { Colours } from "../../../utils/colours";
import WrappedSection from "../../WrappedSection/WrappedSection";
import * as styles from "./ParagraphDogSizes.module.scss";

interface BreedSizeBlockData {
	description: string;
	breedSize: string;
	breedsBySize: Queries.BreedContentDataFragment[];
}
export interface ParagraphDogSizesProps {
	title: string;
	breedSizeBlocks: BreedSizeBlockData[];
}

export const getParagraphDogSizesProps = ({
	field_title,
	relationships: { field_breed_size_block },
}: Queries.ParagraphDogSizesDataFragment): ParagraphDogSizesProps => ({
	title: field_title,
	breedSizeBlocks: field_breed_size_block.map((sizeBlock) => ({
		description: sizeBlock.field_breed_size_description,
		breedSize: sizeBlock.relationships.field_breed_size.name,
		breedsBySize: sizeBlock.breedsBySize.map((breed) => ({
			...breed,
		})),
	})),
});

export const ParagraphDogSizes: React.FC<ParagraphDogSizesProps> = ({
	title,
	breedSizeBlocks,
}) => {
	const firstTwoItems = breedSizeBlocks.slice(0, 2);
	const remainingItems = breedSizeBlocks.slice(2);

	return (
		<>
			<WrappedSection
				sectionName="ParagraphDogSizes"
				sectionColour={Colours.SUNSHINE_YELLOW}
			>
				<div className={styles.inner}>
					<h2>{title}</h2>
					{firstTwoItems.map((sizeBlock) => (
						<article key={sizeBlock.breedSize} className={styles.sizeblock}>
							<div className={styles.sizeblockdetails}>
								<h2
									className={styles.title}
								>{`${sizeBlock.breedSize} dog breeds`}</h2>
								<p>{sizeBlock.description}</p>
								<Button
									url={`/dog-advice/getting-dog/breeds/dogs?${qs.stringify({
										size: sizeBlock.breedSize,
									})}`}
									variant="secondary"
								>{`Search all ${sizeBlock.breedSize} dogs`}</Button>
							</div>
							<div className={styles.sizeblockcarouselcontainer}>
								{sizeBlock.breedsBySize.length > 0 && (
									<BreedCardCarousel
										navTheme="white"
										breeds={sizeBlock.breedsBySize}
										isStandalone={false}
									/>
								)}
							</div>
						</article>
					))}
				</div>
			</WrappedSection>
			{remainingItems.length > 0 && (
				<WrappedSection
					sectionName="ParagraphDogSizesSecondary"
					sectionColour={Colours.SANDY_FUR}
				>
					<div className={styles.inner}>
						{remainingItems.map((sizeBlock) => (
							<article key={sizeBlock.breedSize} className={styles.sizeblock}>
								<div className={styles.sizeblockdetails}>
									<h2
										className={styles.title}
									>{`${sizeBlock.breedSize} dog breeds`}</h2>
									<p>{sizeBlock.description}</p>
									<Button
										url={`/dog-advice/getting-dog/breeds/dogs?${qs.stringify({
											size: sizeBlock.breedSize,
										})}`}
										variant="secondary"
									>{`Search all ${sizeBlock.breedSize} dogs`}</Button>
								</div>
								<div className={styles.sizeblockcarouselcontainer}>
									{sizeBlock.breedsBySize.length > 0 && (
										<BreedCardCarousel
											breeds={sizeBlock.breedsBySize}
											isStandalone={false}
										/>
									)}
								</div>
							</article>
						))}
					</div>
				</WrappedSection>
			)}
		</>
	);
};

export default ParagraphDogSizes;
